import { objectFlip } from '../utils/functions';

export const TextCaseType = {
  OPTIONS: 'Lista de Opções',
  TEXT: 'Texto',
};

export const TextCaseTypeInverted = objectFlip(TextCaseType);

export const TestCaseStatus = {
  FAIL: 'Falha',
  SUCCESS: 'Sucesso',
  IN_PROGRESS: 'Em execução',
  NOT_EXECUTED: 'Não executado',
  ERROR: 'Erro',
};

export class ExpectedResultDTO {
  constructor(type = TextCaseType.TEXT) {
    this.type = type;
    this.text = 'Mensagem esperada como resposta do chatbot';

    if (type === TextCaseType.OPTIONS) {
      this.options = ['Opção 1', 'Opção 2'];
    }
  }
}

export default class TestCaseDTO {
  constructor(testCase) {
    this.status = TestCaseStatus.NOT_EXECUTED;

    if (testCase == null) {
      this.message = 'INITIALMESSAGE1';
      this.expectedResult = [new ExpectedResultDTO()];
    } else {
      this.id = testCase.id;
      this.message = testCase.message;
      this.next = testCase.next;
      this.previous = testCase.previous;
      this.expectedResult = JSON.parse(testCase.expectedResult);
    }
  }

  mapToResquest() {
    return {
      id: this.id,
      message: this.message,
      expectedResult: JSON.stringify(this.expectedResult),
      previous: this.previous,
      suite: this.suite ? { id: this.suite } : undefined,
    };
  }
}
